import theme from '../../themes/sovos-theme';
const green = {
  components: {
    SovosNavigation: {
      styleOverrides: {
        highlights: "#7EBB69",
        gradientBottom: "#2D4A24",
        gradientTop: "#212531"
      }
    }
  }
};
const brown = {
  components: {
    SovosNavigation: {
      styleOverrides: {
        highlights: "#FAE58F",
        gradientBottom: "#86450E",
        gradientTop: "#6C2C11"
      }
    }
  }
};
const purple = {
  components: {
    SovosNavigation: {
      styleOverrides: {
        highlights: "#A56BD3",
        gradientBottom: "#422558",
        gradientTop: "#40284E"
      }
    }
  }
};
const {
  components: {
    SovosNavigation: {
      styleOverrides
    }
  }
} = theme;
const customThemeColors = [{
  title: 'Mosaic (default)',
  colors: {
    ...styleOverrides
  }
}, {
  title: 'Green',
  colors: {
    ...styleOverrides,
    ...green.components.SovosNavigation.styleOverrides
  }
}, {
  title: 'Brown',
  colors: {
    ...styleOverrides,
    ...brown.components.SovosNavigation.styleOverrides
  }
}, {
  title: 'Purple',
  colors: {
    ...styleOverrides,
    ...purple.components.SovosNavigation.styleOverrides
  }
}, {
  title: 'Custom',
  colors: {
    ...styleOverrides
  }
}];
export default customThemeColors;